import type { PropsWithChildren, ReactNode } from 'react';

export function Battery({ percentage, exact }: { percentage: number; exact?: string }) {
  const level = Math.max(0, Math.min(100, percentage));
  return (
    <div className="battery-wrap" aria-label={`Batteria ${level}%`}>
      <div className="battery">
        {/* rect + attributi geometrici: la CSP senza 'unsafe-inline' blocca gli attributi style. */}
        <svg className="battery__gauge" viewBox="0 0 100 100" preserveAspectRatio="none" aria-hidden="true">
          <rect className={`battery__fill ${level <= 15 ? 'battery__fill--critical' : ''}`} x="0" y="0" width={level} height="100" />
        </svg>
      </div>
      <span>{exact ?? `${level}%`}</span>
    </div>
  );
}

export function Device({ children, title = 'TERMINALE', battery, actions }: PropsWithChildren<{ title?: string; battery?: number; actions?: ReactNode }>) {
  return (
    <main className="device-shell">
      <div className="device-rivet device-rivet--tl" />
      <div className="device-rivet device-rivet--tr" />
      <header className="device-header">
        <div>
          <span className="eyebrow">RELICT NETWORK TERMINAL</span>
          <h1>{title}</h1>
        </div>
        {typeof battery === 'number' ? <Battery percentage={battery} /> : null}
      </header>
      <section className="crt">
        <div className="scanline" />
        <div className="crt-content">{children}</div>
      </section>
      {actions ? <footer className="device-actions">{actions}</footer> : null}
    </main>
  );
}

export function Notice({ children, kind = 'info' }: PropsWithChildren<{ kind?: 'info' | 'error' | 'success' }>) {
  return <div className={`notice notice--${kind}`}>{children}</div>;
}

export function Spinner({ label = 'ELABORAZIONE' }: { label?: string }) {
  return <div className="spinner" role="status"><span /> {label}<i>...</i></div>;
}
